import { combineReducers } from "redux";
import constants from "./constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  opportunityList: createApiReducer(constants.OPPORTUNITY_LIST, {}),
  lowPerformanceKeywords: createApiReducer(constants.LOW_PERFORMANCE_KEYWORDS, {}),
});

export default reducers;
